import React from "react";
import { Card } from "react-bootstrap";
function TermInfo() {
  return (
    <Card>
      <Card.Header>TodToli үйлчилгээний нөхцөл</Card.Header>
      <Card.Body>
        <Card.Title>TodToli-ийн зүгээс:</Card.Title>
        <ul>
          <li>
            <Card.Text>
              Бид аппликейшны найдвартай ажиллагааг хангаж ажиллана.
            </Card.Text>
          </li>
          <li>
            <Card.Text>Хэрэглэгчдээ үнэн бодиттой мэдээлэл хүргэнэ.</Card.Text>
          </li>
          <li>
            <Card.Text>
              TodToli-ийг бүрэн ашиглахын тулд апп нэвтрэх хэрэгтэй ба бид
              хүүхэд болон том хүн бүгд ашиглах боломжтой Gmail, Facebook-ээр
              нэвтрэх боломжийг бүрдүүлсэн бөгөөд хэрэглэгчийн мэдээллийг ямар
              нэг гуравдагч этгээдэд дамжуулаагүй болно.
            </Card.Text>
          </li>
          <li>
            <Card.Text>
              Хэрэглэгчдийн хувийн мэдээллийн аюулгүй байдлыг хангаж ажиллана.
            </Card.Text>
          </li>
        </ul>
      </Card.Body>

      <Card.Body>
        <Card.Title>Хэрэглэгчийн зүгээс:</Card.Title>
        <ul>
          <li>
            <Card.Text>Өөрийн бүртгэлийг бусдад дамжуулахгүй байх.</Card.Text>
          </li>
          <li>
            <Card.Text>
              Аппликейшны мэдээ мэдээллийг зөвшөөрөлгүй бусдад тараахгүй байх.
              Тараасан тохиолдолд хуулийн хариуцлага хүлээнэ.
            </Card.Text>
          </li>
        </ul>
        <Card.Text>
          TodToli-д бүртгэл үүсгэн ашиглаж байгаа хүнийг дээрх үйлчилгээний
          нөхцөлүүдийг хүлээн зөвшөөрсөн гэж үзнэ.
        </Card.Text>
      </Card.Body>
    </Card>
  );
}
export default TermInfo;
